import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Href } from 'components/ui/Href/Href'
import { Flex, Image, Text } from 'components/uiKit'
import { getAltFromSrc } from 'utils/helpers/getAltFromSrc/getAltFromSrc'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'
import { colors } from 'shared/constants/values'

import s from './Chat.module.scss'

export type MessagesType = {
  name: string
  text: string
  me: boolean
  date: Date
  time?: string
  photos?: string[]
  videos?: string[]
}

type ChatProps = {
  messages: MessagesType[]
}

export const Chat = ({ messages }: ChatProps) => {
  const { t } = useTranslation()

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current && messages.length) {
      ref.current.scrollTop = ref.current.scrollHeight
    }
  }, [messages])

  return (
    <div className={s.Chat} ref={ref}>
      <Flex vertical gap={8}>
        {messages.map((message, index) => (
          <Flex key={index} className={s.messageWrap} justify={message.me ? 'flex-end' : 'flex-start'}>
            <Flex className={`${s.message} ${message.me ? s.messageFromMe : s.messageNotFromMe}`} vertical gap={8}>
              <Text strong color={colors.corp}>
                {message.name}
              </Text>

              <Text>{message.text}</Text>

              <Flex wrap gap={8}>
                {message.photos?.map((file) => <Image key={file} height={200} src={file} alt={getAltFromSrc(file)} />)}
              </Flex>

              {message.videos?.map((file) => (
                <Flex key={file}>
                  <Href href={file} linkType="search">
                    {t(getSharedKey('videoURL'))}
                  </Href>
                </Flex>
              ))}

              <Flex className={s.timeWrap} justify="flex-end">
                <Text type="secondary">{message.time}</Text>
              </Flex>
            </Flex>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}
